import { LOCALE } from "core/interfaces";

import { extractTranslation } from "~/common/helpers/extract-translation";
import type { Collection, CollectionAdapted } from "~/common/interfaces/entities/collection.interface";

export const collectionDenormalize = (collectionAdapted: CollectionAdapted): Collection => {
	const { name: _name, ...rest } = collectionAdapted;

	return {
		...rest
	};
};

export const collectionNormalize = (locale: Ref<LOCALE>, collection: Collection): CollectionAdapted => {
	const { translations, ...rest } = collection;

	const translation = extractTranslation(locale.value, translations);

	return {
		name: translation ? translation.name : "NAME",
		translations,
		...rest
	};
};
